// Copy of center/src/forms/RegisterPatientForm/AdmissionDateInput.tsx
import { useFormContext } from "react-hook-form";
import InputField from "@medoma/components/InputField/InputField";
import { machineFormat } from "@medoma/models/date-and-time";
import { dateMonthAndYear } from "@/Utils/DateUtils";
import { useLingui } from "@lingui/react/macro";

export type AdmissionDateInputFields = {
  admissionDate: string;
};

const AdmissionDateInput = ({ registeredAt }: { registeredAt: Date }) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<AdmissionDateInputFields>();

  const registrationDate = dateMonthAndYear(registeredAt);

  return (
    <InputField
      label={t`Inskrivningsdatum`}
      showOptionalLabel={false}
      type="date"
      errorMessage={errors.admissionDate?.message}
      {...register("admissionDate", {
        required: {
          value: true,
          message: t`Ange inskrivningsdatum`,
        },
        min: {
          value: machineFormat(registeredAt, "yyyy-MM-dd"),
          message: t`Patienten registrerades ${registrationDate}. Inskrivningsdatumet kan inte vara tidigare än så.`,
        },
        max: {
          value: machineFormat(new Date(), "yyyy-MM-dd"),
          message: t`Inskrivningsdatumet kan inte vara i framtiden`,
        },
      })}
    />
  );
};

export default AdmissionDateInput;
